import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Paper } from "@mui/material";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";
import server from "../functions/server";
import BKGLogin from "../img/img-tela-login.png";
import MediaQuery from "react-responsive";
import { supportNumber } from "../utils/supportNumber";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function ChamadoCanfield(props) {
  const [dialog, openDialog] = React.useState(false);
  const [chamadoID, setChamadoID] = React.useState(0);
  const [dialogConsulta, setDialogConsulta] = React.useState(false);
  const [dialogSerie, setDialogSerie] = React.useState(false);
  const [consulta, setConsulta] = React.useState(false);

  const handleNuChamado = (event) => {
    setChamadoID(event.target.value);
  };

  const handleConsulta = () => {
    fetch(server + "consulta_otobo", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        nuchamado: chamadoID,
      }),
    })
      .then((resp) => resp.json())
      .then((reqres) => {
        setConsulta(reqres.data);
      });
  };

  let stylecard = {
    paddingTop: 0.05,
    flexGrow: 1,
    alignSelf: "center",
  };

  const trataHist = (hist) => {
    if (hist === "NewTicket") {
      return "Abertura";
    } else if (hist === "AddNote") {
      return "Nota";
    } else if (hist === "StateUpdate") {
      return "Estado";
    } else if (hist === "OwnerUpdate") {
      return "Fila";
    } else {
      return null;
    }
  };

  const trataAcao = (acao) => {
    if (acao.includes("Canfield")) {
      return "Nº do Ticket: " + acao.slice(0, 15);
    } else if (acao.includes("GenericInterface Create")) {
      return "Chamado aberto com Sucesso";
    } else if (acao.includes("api.otobo")) {
      return "Inserido na fila de atendimento";
    } else if (acao.includes("Note")) {
      return "Nota adicionada ao chamado";
    } else if (acao.includes(".")) {
      return (
        "Analista " +
        acao
          .replace(".", " ")
          .replace(/[0-9]/g, "")
          .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase()) +
        " iniciou atendimento."
      );
    } else if (acao.includes("Owner")) {
      return "Inicio de Atendimento";
    } else if (acao.includes("pending")) {
      return "Chamado em estado pendente";
    } else if (acao.includes("Pending")) {
      return "Adicionada nota de pendência";
    } else if (acao.includes("Close")) {
      return "Chamado encerrado";
    } else if (acao.replace(/\s/g, "").includes("closedsuccessfulopen")) {
      return "Chamado reaberto";
    } else if (acao.replace(/\s/g, "").includes("openclosedsuccessful")) {
      return "Chamado encerrado";
    } else {
      return acao;
    }
  };

  const trataData = (data) => {
    let newData = data.slice(0, 10);
    newData =
      data.slice(8, 10) + "/" + data.slice(5, 7) + "/" + data.slice(0, 4);
    return newData;
  };

  return (
    <>
      <Dialog
        open={dialog}
        onClose={() => {
          openDialog(false);
          window.location.reload();
        }}
      >
        <DialogTitle>Aviso</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {chamadoID === "SERIE_NAO_CADASTRADA"
              ? "O número de série está incorreto."
              : chamadoID === undefined
                ? `Escolha uma necessidade que esteja de acordo com o Produto selecionado.`
                : `O Chamado nº ${chamadoID} foi aberto com sucesso!`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              openDialog(false);
              window.location.href = "http://medsystems.com.br";
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={dialogSerie} onClose={() => setDialogSerie(false)}>
        <DialogTitle>Aviso</DialogTitle>
        <DialogContent>
          <DialogContentText>
            O número de série do seu equipamento pode estar na parte de baixo da
            câmera. Se for o Vectra (Começa com H2**** ou H1*****), se for o
            Visia fica na parte de trás do equipamento (Começa com V7**** ou
            9****), Vectra XT ou Intellistudio fica na parte de baixo do
            equipamento proximo ao cabo de energia. Para o Mirror, existe um
            pendrive verde com o numero de série.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setDialogSerie(false)}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={dialogConsulta} onClose={() => setDialogConsulta(false)}>
        <DialogTitle>Consultar Chamado</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Insira o nº do chamado para consultar o status do mesmo.
          </DialogContentText>
          <TextField
            id="NUCHAMADO"
            name="NUCHAMADO"
            sx={{ width: "100%" }}
            onChange={handleNuChamado}
          ></TextField>
          <Grid container spacing={2} sx={{ marginTop: 2 }}>
            <Grid item xs={3}>
              <Item>Tipo</Item>
            </Grid>
            <Grid item xs={6}>
              <Item>Ação</Item>
            </Grid>
            <Grid item xs={3}>
              <Item>Hora</Item>
            </Grid>
          </Grid>

          {!consulta ? null : (
            <Grid container spacing={2} sx={{ marginTop: 0.2 }}>
              {consulta.map((linha) =>
                trataHist(linha.HistoryType) == null ? null : (
                  <>
                    <Grid item xs={3}>
                      <Item>{trataHist(linha.HistoryType)}</Item>
                    </Grid>
                    <Grid item xs={6}>
                      <Item>{trataAcao(linha.Name.replace(/%/g, " "))}</Item>
                    </Grid>
                    <Grid item xs={3}>
                      <Item>{trataData(linha.CreateTime)}</Item>
                    </Grid>
                  </>
                )
              )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setDialogConsulta(false)}>
            Cancelar
          </Button>
          <Button autoFocus onClick={() => handleConsulta()}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="fixed" color="default">
          <Toolbar
            sx={{
              pr: "24px",
              justifyContent: "space-between",
            }}
          >
            <Typography
              component="div"
              variant="div"
              color="inherit"
              alignItems="flex-start"
              sx={{ ml: 2 }}
            >
              <img
                height={35}
                sx={{ mt: 0.5 }}
                alt={"Logo MedSystems"}
                src={server + "arquivos/img/medsystems.png"}
              />
              {/* Inserir aqui futuros botões da navbar */}
            </Typography>
          </Toolbar>
        </AppBar>
      </Box>
      <Grid direction="row" sx={{ display: "flex", mt: 6 }}>
        <MediaQuery orientation="landscape">
          <Grid
            item
            xs={false}
            sm={4}
            md={20}
            sx={{
              backgroundImage: `url(${BKGLogin})`,
              flexGrow: 2,
              filter: "brightness(0.7)",
              backgroundRepeat: "no-repeat",
              backgroundColor: (t) =>
                t.palette.mode === "light"
                  ? t.palette.grey[50]
                  : t.palette.grey[900],
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
        </MediaQuery>
        <Box
          component="form"
          sx={{
            padding: 4,
            flexGrow: 1,
          }}
        >
          <Paper sx={stylecard} variant="elevation">
            <Grid sx={{ paddingLeft: 2, paddingRight: 2 }}>
              <h1
              //style={{ color: "#022C57" }}
              >
                Solicitação de suporte
              </h1>
              <p>Solicitação de suporte para os produtos Canfield.</p>
            </Grid>

            <Grid
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                background:
                  "linear-gradient(90deg, #3A75A7 4.91%, #C03F77 48.55%, #FF7600 98.01%) !important",
              }}
            >
              <br />
            </Grid>
          </Paper>

          <h2>Olá! Agradecemos o contato</h2>
          <p>
            Nosso canal de atendimento mudou peço que entre em contato em nosso
            novo número:
          </p>
          <p>
            {supportNumber.phone} ou acesse o link:{" "}
            <a href={`https://wa.me/${supportNumber.whatsApp}`}>
              https://wa.me/{supportNumber.whatsApp}
            </a>
          </p>
        </Box>
      </Grid>
    </>
  );
}

export default ChamadoCanfield;
